export default "__VITE_ASSET__B$VdXpY5__"